import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetGamificationStats, UpdateGamificationStats, GetGamificationBadges, RecordDailyUpdatePoints } from "helpers/api_method";

export const getGamificationStats = createAsyncThunk(
    "dailyupdates/getGamificationStats",
    async (user_name?: string) => {
        try {
            const response = await GetGamificationStats(user_name);
            return response.data || response;
        } catch (error) {
            return error;
        }
    }
);

export const updateGamificationStats = createAsyncThunk(
    "dailyupdates/updateGamificationStats",
    async (data: any) => {
        try {
            const response = await UpdateGamificationStats(data);
            return response.data || response;
        } catch (error) {
            return error;
        }
    }
);

export const getGamificationBadges = createAsyncThunk(
    "dailyupdates/getGamificationBadges",
    async (user_name?: string) => {
        try {
            const response = await GetGamificationBadges(user_name);
            return response.data || response;
        } catch (error) {
            return error;
        }
    }
);

export const recordDailyUpdatePoints = createAsyncThunk(
    "dailyupdates/recordDailyUpdatePoints",
    async (data: any) => {
        try {
            const response = await RecordDailyUpdatePoints(data);
            return response.data || response;
        } catch (error) {
            return error;
        }
    }
);

